
import React from 'react';
import { useAuth } from '@/hooks/useAuth';

const SuperUserDashboard = () => {
  const { user } = useAuth();
  
  return (
    <div className="container mx-auto p-4">
      <h1 className="text-2xl font-bold mb-4">Super User Dashboard</h1>
      {user && (
        <p>Logged in as {user.email}</p>
      )}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
        <div className="bg-white p-6 rounded-lg shadow">
          <h2 className="text-xl font-semibold mb-4">System Status</h2>
          <p>All systems operational</p>
        </div>
        <div className="bg-white p-6 rounded-lg shadow">
          <h2 className="text-xl font-semibold mb-4">User Statistics</h2>
          <p>Total users: 25</p>
          <p>Active users: 18</p>
        </div>
      </div>
    </div>
  );
};

export default SuperUserDashboard;
